import { ImsCostingMethod } from "@redotech/crdb-enums/inventory/ims-costing-method";
import * as z from "zod";

export const getCostingMethod = {
  name: "getCostingMethod" as const,
  input: z.object({}),
  output: z.object({ costingMethod: z.enum(ImsCostingMethod) }),
};
